module.exports = __webpack_public_path__ + "static/media/cost-and-revenue-impact.73478e92.svg";